import type { EmployeeRole } from '@repo/types';
import { cn } from '@/lib/utils';

interface RoleBadgeProps {
  role: EmployeeRole;
  className?: string;
}

const roleConfig: Record<EmployeeRole, { label: string; className: string }> = {
  job_scout: {
    label: 'Job Scout',
    className: 'border-blue-500/20 bg-blue-500/10 text-blue-700 dark:text-blue-400',
  },
  team_lead: {
    label: 'Team Lead',
    className: 'border-emerald-500/20 bg-emerald-500/10 text-emerald-700 dark:text-emerald-400',
  },
  manager: {
    label: 'Manager',
    className: 'border-violet-500/20 bg-violet-500/10 text-violet-700 dark:text-violet-400',
  },
  admin: {
    label: 'Admin',
    className: 'border-amber-500/20 bg-amber-500/10 text-amber-700 dark:text-amber-400',
  },
};

export function RoleBadge({ role, className }: RoleBadgeProps) {
  const config = roleConfig[role] ?? roleConfig.job_scout;
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        config.className,
        className
      )}
    >
      {config.label}
    </span>
  );
}
